// import React, { useState, useRef, useEffect } from "react";
// import {
//   Box,
//   FormControl,
//   Select,
//   MenuItem,
//   Alert,
//   Snackbar,
//   Card,
//   Typography,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
// } from "@mui/material";
// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";
// import interactionPlugin from "@fullcalendar/interaction";
// import SoftBox from "components/SoftBox";
// import SoftButton from "components/SoftButton";
// import SoftTypography from "components/SoftTypography";
// import SoftInput from "components/SoftInput";
// import { styled } from "@mui/material/styles";
// import CalendarRoot from "examples/Calendar/CalendarRoot";
// import UploadFileIcon from "@mui/icons-material/UploadFile";
// import AddIcon from "@mui/icons-material/Add";
// import * as XLSX from "xlsx";

// import { uploadHolidays, getHolidays } from "api/holidayApi";

// const Holiday = () => {
//   const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
//   const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//   const [holidays, setHolidays] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [uploadLoading, setUploadLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const [excelData, setExcelData] = useState([]);
//   const [excelFile, setExcelFile] = useState(null);
//   const [addDialogOpen, setAddDialogOpen] = useState(false);
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const calendarRef = useRef(null);

//   // Form state for new holiday
//   const [newHoliday, setNewHoliday] = useState({
//     title: "",
//     date: "",
//     description: ""
//   });

//   // Fetch holidays on component mount
//   useEffect(() => {
//     fetchHolidays();
//   }, []);

//   const fetchHolidays = async () => {
//     setLoading(true);
//     try {
//       const response = await getHolidays();
//       if (response && response.status === "success" && response.holidays) {
//         const formattedHolidays = response.holidays.map(holiday => ({
//           id: holiday?.id,
//           title: holiday?.title,
//           start: holiday?.holiday_date,
//           allDay: true,
//           day: holiday.day,
//           extendedProps: {
//             description: holiday?.description || ""
//           }
//         }));
//         setHolidays(formattedHolidays);
//       }
//     } catch (error) {
//       console.error("Error fetching holidays:", error);
//       showSnackbar("Error fetching holidays", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const showSnackbar = (message, severity = "success") => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const handleExcelUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setExcelFile(file);

//     const reader = new FileReader();
//     reader.onload = (evt) => {
//       const bstr = evt.target.result;
//       const wb = XLSX.read(bstr, { type: "binary" });
//       const wsname = wb.SheetNames[0];
//       const ws = wb.Sheets[wsname];
//       const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

//       // Format data according to expected Excel structure
//       // Expected format: [Title, Date, Description] or [Title, Date]
//       const formattedData = data.slice(1).map((row, index) => ({
//         id: `excel-${index}`,
//         title: row[0] || "",
//         start: row[1] ? formatDate(row[1]) : "",
//         allDay: true,
//         day: row[1] ? getDayName(row[1]) : "",
//         extendedProps: {
//           description: row[2] || "",
//           isExcelData: true
//         }
//       })).filter(item => item.title && item.start); // Filter out empty rows

//       setExcelData(formattedData);
//     };

//     reader.readAsBinaryString(file);
//   };

//   const formatDate = (dateValue) => {
//     // Handle different date formats from Excel
//     if (typeof dateValue === 'number') {
//       // Excel serial date
//       const date = XLSX.SSF.parse_date_code(dateValue);
//       return `${date.y}-${String(date.m).padStart(2, '0')}-${String(date.d).padStart(2, '0')}`;
//     } else if (typeof dateValue === 'string') {
//       // String date - try to parse
//       const date = new Date(dateValue);
//       if (!isNaN(date)) {
//         return date.toISOString().split('T')[0];
//       }
//     }
//     return dateValue;
//   };

//   const getDayName = (dateValue) => {
//     const date = new Date(formatDate(dateValue));
//     return date.toLocaleDateString('en-US', { weekday: 'long' });
//   };

//   const handleUploadSubmit = async () => {
//     if (!excelFile) {
//       showSnackbar("Please upload an Excel file", "error");
//       return;
//     }

//     setUploadLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append("file", excelFile);

//       const response = await uploadHolidays(formData);

//       if (response.status === "success") {
//         showSnackbar(`Holidays uploaded successfully! Inserted: ${response.inserted_count} holidays`);
//         setExcelFile(null);
//         setExcelData([]);
//         // Reset file input
//         const fileInput = document.querySelector('input[type="file"]');
//         if (fileInput) fileInput.value = "";

//         // Refresh holidays list
//         fetchHolidays();
//       } else {
//         showSnackbar("Failed to upload holidays", "error");
//       }
//     } catch (error) {
//       console.error("Error uploading holidays:", error);
//       showSnackbar("Error uploading holidays", "error");
//     } finally {
//       setUploadLoading(false);
//     }
//   };

//   const handleAddHoliday = async () => {
//     if (!newHoliday.title || !newHoliday.date) {
//       showSnackbar("Please fill in all required fields", "error");
//       return;
//     }

//     // Since we don't have an API for adding individual holidays,
//     // we'll show a message to use Excel upload
//     showSnackbar("Please use Excel upload to add new holidays", "info");
//     setAddDialogOpen(false);
//     setNewHoliday({ title: "", date: "", description: "" });
//   };

//   const handleEventClick = (info) => {
//     setSelectedEvent(info.event);
//     setEditDialogOpen(true);
//   };

//   const handleUpdateHoliday = async () => {
//     // Since we don't have update API, show info message
//     showSnackbar("Please use Excel upload to update holidays", "info");
//     setEditDialogOpen(false);
//     setSelectedEvent(null);
//   };

//   const handleDeleteHoliday = async () => {
//     // Since we don't have delete API, show info message
//     showSnackbar("Please contact admin to delete holidays", "info");
//     setEditDialogOpen(false);
//     setSelectedEvent(null);
//   };

//   // Handle date change
//   const handleDateChange = () => {
//     if (calendarRef.current) {
//       const newDate = new Date(selectedYear, selectedMonth, 1);
//       const calendarApi = calendarRef.current.getApi();
//       calendarApi.gotoDate(newDate);
//     }
//   };

//   // Update calendar when month/year changes
//   React.useEffect(() => {
//     handleDateChange();
//   }, [selectedMonth, selectedYear]);

//   // Combine API holidays with Excel preview data
//   const calendarEvents = [...holidays, ...excelData];

//   // Filter holidays for current year
//   const currentYearHolidays = holidays.filter(holiday =>
//     new Date(holiday.start).getFullYear() === selectedYear
//   );

//   return (
//     <SoftBox>
//       <Card sx={{ p: 3, mb: 3 }}>
//         <SoftTypography variant="h6" gutterBottom>
//           Upload Holidays via Excel
//         </SoftTypography>
//         <Box display="flex" alignItems="center" gap={2} mb={2}>
//           <SoftButton
//             component="label"
//             variant="outlined"
//             color="info"
//             startIcon={<UploadFileIcon />}
//           >
//             Upload Excel File
//             <input
//               type="file"
//               accept=".xlsx, .xls"
//               hidden
//               onChange={handleExcelUpload}
//             />
//           </SoftButton>

//           {excelFile && (
//             <SoftTypography variant="caption">
//               Selected: {excelFile.name}
//             </SoftTypography>
//           )}
//         </Box>

//         {excelData.length > 0 && (
//           <Box mt={2}>
//             <SoftTypography variant="h6" gutterBottom>
//               Preview Uploaded Data ({excelData.length} holidays)
//             </SoftTypography>
//             <Box display="flex" flexDirection="column" gap={1} maxHeight="300px" overflow="auto">
//               {excelData.map((holiday, index) => (
//                 <Box
//                   key={index}
//                   display="flex"
//                   justifyContent="space-between"
//                   alignItems="center"
//                   p={2}
//                   sx={{
//                     backgroundColor: "background.paper",
//                     borderRadius: 1,
//                     border: "1px solid",
//                     borderColor: "divider",
//                   }}
//                 >
//                   <Box flex={1}>
//                     <strong>{holiday.title}</strong>
//                     <Box color="text.secondary" fontSize="0.875rem">
//                       {holiday.start && new Date(holiday.start).toLocaleDateString('en-IN', {
//                         weekday: 'long',
//                         year: 'numeric',
//                         month: 'long',
//                         day: 'numeric'
//                       })}
//                     </Box>
//                     {holiday.extendedProps?.description && (
//                       <Box color="text.secondary" fontSize="0.75rem" mt={0.5}>
//                         {holiday.extendedProps?.description}
//                       </Box>
//                     )}
//                   </Box>
//                   <Box
//                     sx={{
//                       backgroundColor: "info.main",
//                       color: "white",
//                       px: 1,
//                       py: 0.5,
//                       borderRadius: 1,
//                       fontSize: "0.75rem",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     New
//                   </Box>
//                 </Box>
//               ))}
//             </Box>
//             <SoftButton
//               variant="gradient"
//               color="info"
//               onClick={handleUploadSubmit}
//               disabled={uploadLoading}
//               loading={uploadLoading}
//               sx={{ mt: 2 }}
//             >
//               {uploadLoading ? "Uploading..." : `Upload ${excelData.length} Holidays`}
//             </SoftButton>
//           </Box>
//         )}
//       </Card>

//       {/* Calendar Controls */}
//       <Card sx={{ p: 3, mb: 3 }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//           <Box display="flex" gap={2}>
//             <FormControl size="small" sx={{ minWidth: 120 }}>
//               <Select
//                 value={selectedMonth}
//                 onChange={(e) => setSelectedMonth(e.target.value)}
//               >
//                 {[
//                   "Jan", "Feb", "Mar", "Apr", "May", "Jun",
//                   "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
//                 ].map((month, index) => (
//                   <MenuItem key={month} value={index}>
//                     {month}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl size="small" sx={{ minWidth: 120 }}>
//               <Select
//                 value={selectedYear}
//                 onChange={(e) => setSelectedYear(e.target.value)}
//               >
//                 {Array.from({ length: 10 }, (_, i) => {
//                   const year = new Date().getFullYear() - 2 + i;
//                   return (
//                     <MenuItem key={year} value={year}>
//                       {year}
//                     </MenuItem>
//                   );
//                 })}
//               </Select>
//             </FormControl>
//           </Box>

//           <SoftBox display="flex" alignItems="center" gap={1}>
//             <SoftTypography variant="body2" color="textSecondary">
//               {currentYearHolidays.length} holidays in {selectedYear}
//             </SoftTypography>
//           </SoftBox>
//         </Box>

//         {/* Calendar */}
//         <CalendarRoot>
//           <FullCalendar
//             ref={calendarRef}
//             plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
//             initialView="dayGridMonth"
//             editable={false}
//             selectable={false}
//             events={calendarEvents}
//             eventClick={handleEventClick}
//             height="auto"
//             headerToolbar={{
//               left: "prev",
//               center: "title",
//               right: "today,next",
//             }}
//             eventContent={(arg) => (
//               <div
//                 style={{
//                   background: arg.event.extendedProps.isExcelData
//                     ? "linear-gradient(to right, #4CAF50, #45a049)"
//                     : "linear-gradient(to right, #33ccff, #ff99cc)",
//                   borderRadius: "4px",
//                   padding: "2px 4px",
//                   color: "#fff",
//                   fontSize: "0.85rem",
//                   overflow: "hidden",
//                   whiteSpace: "nowrap",
//                   textOverflow: "ellipsis",
//                   cursor: "pointer",
//                 }}
//                 title={arg.event.title}
//               >
//                 {arg.event.title}
//               </div>
//             )}
//           />
//         </CalendarRoot>
//       </Card>

//       {/* Upcoming Holidays List */}
//       <Card sx={{ p: 3 }}>
//         <Typography variant="h6" gutterBottom>
//           Upcoming Holidays ({selectedYear})
//         </Typography>
//         {currentYearHolidays.length === 0 ? (
//           <SoftTypography variant="body2" color="textSecondary" textAlign="center" py={3}>
//             No holidays found for {selectedYear}
//           </SoftTypography>
//         ) : (
//           <Box display="flex" flexDirection="column" gap={1}>
//             {currentYearHolidays
//               .filter(event => new Date(event.start) >= new Date())
//               .sort((a, b) => new Date(a.start) - new Date(b.start))
//               .map(event => (
//                 <Box
//                   key={event.id}
//                   display="flex"
//                   justifyContent="space-between"
//                   alignItems="center"
//                   p={2}
//                   sx={{
//                     backgroundColor: "background.paper",
//                     borderRadius: 1,
//                     border: "1px solid",
//                     borderColor: "divider",
//                   }}
//                 >
//                   <Box flex={1}>
//                     <strong>{event.title}</strong>
//                     <Box color="text.secondary" fontSize="0.875rem">
//                       {new Date(event.start).toLocaleDateString('en-IN', {
//                         weekday: 'long',
//                         year: 'numeric',
//                         month: 'long',
//                         day: 'numeric'
//                       })}
//                     </Box>
//                     {event.extendedProps?.description && (
//                       <Box color="text.secondary" fontSize="0.75rem" mt={0.5}>
//                         {event.extendedProps?.description}
//                       </Box>
//                     )}
//                   </Box>
//                   <Box
//                     sx={{
//                       backgroundColor: "primary.main",
//                       color: "white",
//                       px: 1,
//                       py: 0.5,
//                       borderRadius: 1,
//                       fontSize: "0.75rem",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     Holiday
//                   </Box>
//                 </Box>
//               ))}
//           </Box>
//         )}
//       </Card>

//       {/* Add Holiday Dialog */}
//       <Dialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Add New Holiday</DialogTitle>
//         <DialogContent>
//           <SoftBox display="flex" flexDirection="column" gap={2} mt={1}>
//             <SoftInput
//               label="Holiday Title *"
//               value={newHoliday.title}
//               onChange={(e) => setNewHoliday({...newHoliday, title: e.target.value})}
//               fullWidth
//             />
//             <TextField
//               label="Date *"
//               type="date"
//               value={newHoliday.date}
//               onChange={(e) => setNewHoliday({...newHoliday, date: e.target.value})}
//               InputLabelProps={{ shrink: true }}
//               fullWidth
//             />
//             <SoftInput
//               label="Description (Optional)"
//               value={newHoliday?.description}
//               onChange={(e) => setNewHoliday({...newHoliday, description: e.target.value})}
//               multiline
//               rows={3}
//               fullWidth
//             />
//           </SoftBox>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setAddDialogOpen(false)}>Cancel</Button>
//           <Button onClick={handleAddHoliday} variant="contained" color="primary">
//             Add Holiday
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Holiday Dialog */}
//       <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Holiday Details</DialogTitle>
//         <DialogContent>
//           {selectedEvent && (
//             <SoftBox display="flex" flexDirection="column" gap={2} mt={1}>
//               <SoftTypography variant="h6">
//                 {selectedEvent.title}
//               </SoftTypography>
//               <SoftTypography variant="body1">
//                 Date: {new Date(selectedEvent.start).toLocaleDateString('en-IN', {
//                   weekday: 'long',
//                   year: 'numeric',
//                   month: 'long',
//                   day: 'numeric'
//                 })}
//               </SoftTypography>
//               {selectedEvent.extendedProps.description && (
//                 <SoftTypography variant="body2" color="textSecondary">
//                   Description: {selectedEvent.extendedProps?.description}
//                 </SoftTypography>
//               )}
//               <SoftTypography variant="caption" color="textSecondary" mt={2}>
//                 Note: To modify holidays, please use the Excel upload feature.
//               </SoftTypography>
//             </SoftBox>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={handleDeleteHoliday}
//             color="error"
//           >
//             Delete
//           </Button>
//           <Button onClick={() => setEditDialogOpen(false)}>Close</Button>
//           <Button onClick={handleUpdateHoliday} variant="contained" color="primary">
//             Update
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar for notifications */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={snackbar.severity}
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </SoftBox>
//   );
// };

// export default Holiday;

import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Alert,
  Snackbar,
  Card,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Tooltip,
  Paper,
  Chip
} from "@mui/material";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import { styled } from "@mui/material/styles";
import CalendarRoot from "examples/Calendar/CalendarRoot";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AddIcon from "@mui/icons-material/Add";
import * as XLSX from "xlsx";
import EventIcon from "@mui/icons-material/Event";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import { uploadHolidays, getHolidays } from "api/holidayApi";


const Holiday = () => {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [excelData, setExcelData] = useState([]);
  const [excelFile, setExcelFile] = useState(null);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const calendarRef = useRef(null);

  
const HolidayBadge = styled(Box)(({ theme, type }) => ({
  backgroundColor: type === "new" 
    ? "linear-gradient(135deg, #4CAF50 0%, #45a049 100%)" 
    : "linear-gradient(135deg, #2196F3 0%, #1976D2 100%)",
  color: "white",
  padding: "4px 8px",
  borderRadius: "6px",
  fontSize: "0.75rem",
  fontWeight: "bold",
  textAlign: "center",
  whiteSpace: "nowrap",
}));

const HolidayItem = styled(Paper)(({ theme, isnew }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1),
  borderRadius: "8px",
  borderLeft: `4px solid ${isnew === "true" ? "#4CAF50" : "#2196F3"}`,
  background: "white",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
  },
}));

  // Form state for new holiday
  const [newHoliday, setNewHoliday] = useState({
    title: "",
    date: "",
    description: "",
  });

  // Fetch holidays on component mount
  useEffect(() => {
    fetchHolidays();
  }, []);

  const fetchHolidays = async () => {
    setLoading(true);
    try {
      const response = await getHolidays();
      if (response && response.status === "success" && response.holidays) {
        const formattedHolidays = response.holidays.map((holiday) => ({
          id: holiday?.id,
          title: holiday?.title,
          start: holiday?.holiday_date,
          allDay: true,
          day: holiday.day,
          extendedProps: {
            description: holiday?.description || "",
          },
        }));
        setHolidays(formattedHolidays);
      }
    } catch (error) {
      console.error("Error fetching holidays:", error);
      showSnackbar("Error fetching holidays", "error");
    } finally {
      setLoading(false);
    }
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setExcelFile(file);

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

      // Format data according to expected Excel structure
      // Expected format: [Title, Date, Description] or [Title, Date]
      const formattedData = data
        .slice(1)
        .map((row, index) => ({
          id: `excel-${index}`,
          title: row[0] || "",
          start: row[1] ? formatDate(row[1]) : "",
          allDay: true,
          day: row[1] ? getDayName(row[1]) : "",
          extendedProps: {
            description: row[2] || "",
            isExcelData: true,
          },
        }))
        .filter((item) => item.title && item.start); // Filter out empty rows

      setExcelData(formattedData);
    };

    reader.readAsBinaryString(file);
  };

  const formatDate = (dateValue) => {
    // Handle different date formats from Excel
    if (typeof dateValue === "number") {
      // Excel serial date
      const date = XLSX.SSF.parse_date_code(dateValue);
      return `${date.y}-${String(date.m).padStart(2, "0")}-${String(date.d).padStart(2, "0")}`;
    } else if (typeof dateValue === "string") {
      // String date - try to parse
      const date = new Date(dateValue);
      if (!isNaN(date)) {
        return date.toISOString().split("T")[0];
      }
    }
    return dateValue;
  };

  const getDayName = (dateValue) => {
    const date = new Date(formatDate(dateValue));
    return date.toLocaleDateString("en-US", { weekday: "long" });
  };

  const handleUploadSubmit = async () => {
    if (!excelFile) {
      showSnackbar("Please upload an Excel file", "error");
      return;
    }

    setUploadLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", excelFile);

      const response = await uploadHolidays(formData);

      if (response.status === "success") {
        showSnackbar(
          `Holidays uploaded successfully! Inserted: ${response.inserted_count} holidays`
        );
        setExcelFile(null);
        setExcelData([]);
        // Reset file input
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) fileInput.value = "";

        // Refresh holidays list
        fetchHolidays();
      } else {
        showSnackbar("Failed to upload holidays", "error");
      }
    } catch (error) {
      console.error("Error uploading holidays:", error);
      showSnackbar("Error uploading holidays", "error");
    } finally {
      setUploadLoading(false);
    }
  };

  const handleAddHoliday = async () => {
    if (!newHoliday.title || !newHoliday.date) {
      showSnackbar("Please fill in all required fields", "error");
      return;
    }

    // Since we don't have an API for adding individual holidays,
    // we'll show a message to use Excel upload
    showSnackbar("Please use Excel upload to add new holidays", "info");
    setAddDialogOpen(false);
    setNewHoliday({ title: "", date: "", description: "" });
  };

  const handleEventClick = (info) => {
    setSelectedEvent(info.event);
    setViewDialogOpen(true);
  };

  // Custom event render function with better hover effects
  const renderEventContent = (eventInfo) => {
    const isExcelData = eventInfo.event.extendedProps.isExcelData;
    const eventColor = isExcelData ? "#4CAF50" : "#2196F3"; // Green for Excel, Blue for API

    return (
      <Tooltip
        title={
          <Box>
            <strong>{eventInfo.event.title}</strong>
            <br />
            {eventInfo.event.start &&
              new Date(eventInfo.event.start).toLocaleDateString("en-IN", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            {eventInfo.event.extendedProps.description && (
              <>
                <br />
                {eventInfo.event.extendedProps.description}
              </>
            )}
          </Box>
        }
        arrow
        placement="top"
      >
        <Box
          sx={{
            backgroundColor: eventColor,
            color: "white",
            borderRadius: "6px",
            padding: "4px 8px",
            fontSize: "0.85rem",
            fontWeight: "500",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            cursor: "pointer",
            border: `2px solid ${eventColor}`,
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: "white",
              color: eventColor,
              transform: "scale(1.05)",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            },
          }}
        >
          {eventInfo.event.title}
        </Box>
      </Tooltip>
    );
  };

  // Handle date change
  const handleDateChange = () => {
    if (calendarRef.current) {
      const newDate = new Date(selectedYear, selectedMonth, 1);
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(newDate);
    }
  };

  // Update calendar when month/year changes
  React.useEffect(() => {
    handleDateChange();
  }, [selectedMonth, selectedYear]);

  // Combine API holidays with Excel preview data
  const calendarEvents = [...holidays, ...excelData];

  // Filter holidays for current year
  const currentYearHolidays = holidays.filter(
    (holiday) => new Date(holiday.start).getFullYear() === selectedYear
  );

  return (
    <SoftBox>
      <Card sx={{  px: 2, mb: 3 ,pt:2 }}>
        <SoftTypography variant="h6" gutterBottom>
          Upload Holidays via Excel
        </SoftTypography>
        <Box display="flex" alignItems="center" gap={2} mb={2}>
          <SoftButton
            component="label"
            variant="outlined"
            color="info"
            startIcon={<UploadFileIcon />}
          >
            Upload Excel File
            <input type="file" accept=".xlsx, .xls" hidden onChange={handleExcelUpload} />
          </SoftButton>

          {excelFile && (
            <SoftTypography variant="caption">Selected: {excelFile.name}</SoftTypography>
          )}
        </Box>

        {excelData.length > 0 && (
          <Box mt={2}>
            <SoftTypography variant="h6" gutterBottom>
              Preview Uploaded Data ({excelData.length} holidays)
            </SoftTypography>
            <Box display="flex" flexDirection="column" gap={1} maxHeight="300px" overflow="auto">
              {excelData.map((holiday, index) => (
                <Box
                  key={index}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  p={2}
                  sx={{
                    backgroundColor: "background.paper",
                    borderRadius: 1,
                    border: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  <Box flex={1}>
                    <strong>{holiday.title}</strong>
                    <Box color="text.secondary" fontSize="0.875rem">
                      {holiday.start &&
                        new Date(holiday.start).toLocaleDateString("en-IN", {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                    </Box>
                    {holiday.extendedProps?.description && (
                      <Box color="text.secondary" fontSize="0.75rem" mt={0.5}>
                        {holiday.extendedProps?.description}
                      </Box>
                    )}
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "#4CAF50",
                      color: "white",
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: "0.75rem",
                      whiteSpace: "nowrap",
                    }}
                  >
                    New
                  </Box>
                </Box>
              ))}
            </Box>
            <SoftButton
              variant="gradient"
              color="info"
              onClick={handleUploadSubmit}
              disabled={uploadLoading}
              loading={uploadLoading}
              sx={{ mt: 2 }}
            >
              {uploadLoading ? "Uploading..." : `Upload ${excelData.length} Holidays`}
            </SoftButton>
          </Box>
        )}
      </Card>

      {/* Calendar Controls */}
      <Card sx={{ p: 3, mb: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" gap={2}>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                {[
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dec",
                ].map((month, index) => (
                  <MenuItem key={month} value={index}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
                {Array.from({ length: 10 }, (_, i) => {
                  const year = new Date().getFullYear() - 2 + i;
                  return (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>

            <Box display="flex" alignItems="center" gap={1}>
              <Chip
                label={`${currentYearHolidays.length} holidays in ${selectedYear}`}
                color="info"
                variant="outlined"
              />
            </Box>
        </Box>

        {/* Calendar */}
        <CalendarRoot>
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            editable={false}
            selectable={false}
            events={calendarEvents}
            eventClick={handleEventClick}
            eventContent={renderEventContent}
            height="auto"
            headerToolbar={{
              left: "prev",
              center: "title",
              right: "today,next",
            }}
            eventDidMount={(info) => {
              // Additional hover effect using CSS
              info.el.style.transition = "all 0.2s ease-in-out";
            }}
          />
        </CalendarRoot>
      </Card>

      {/* Upcoming Holidays List */}
      <Card sx={{ p: 3, borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom display="flex" alignItems="center">
          <EventIcon sx={{ mr: 1, color: "primary.main" }} />
          Upcoming Holidays ({selectedYear})
        </Typography>

        {currentYearHolidays.length === 0 ? (
          <SoftTypography variant="body2" color="textSecondary" textAlign="center" py={3}>
            No holidays found for {selectedYear}
          </SoftTypography>
        ) : (
          <Box display="flex" flexDirection="column" gap={2}>
            {currentYearHolidays
              .filter((event) => new Date(event.start) >= new Date())
              .sort((a, b) => new Date(a.start) - new Date(b.start))
              .slice(0, 10) // Show only next 10 holidays
              .map((event) => (
                <HolidayItem key={event.id} isnew="false" elevation={1}>
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                    <Box flex={1}>
                      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        {event.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {new Date(event.start).toLocaleDateString("en-IN", {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                      </Typography>
                      {event.extendedProps?.description && (
                        <Typography variant="body2" color="text.secondary" mt={0.5}>
                          {event.extendedProps?.description}
                        </Typography>
                      )}
                    </Box>
                    <HolidayBadge type="existing">Holiday</HolidayBadge>
                  </Box>
                </HolidayItem>
              ))}
          </Box>
        )}
      </Card>

      {/* Add Holiday Dialog */}
      <Dialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add New Holiday</DialogTitle>
        <DialogContent>
          <SoftBox display="flex" flexDirection="column" gap={2} mt={1}>
            <SoftInput
              label="Holiday Title *"
              value={newHoliday.title}
              onChange={(e) => setNewHoliday({ ...newHoliday, title: e.target.value })}
              fullWidth
            />
            <TextField
              label="Date *"
              type="date"
              value={newHoliday.date}
              onChange={(e) => setNewHoliday({ ...newHoliday, date: e.target.value })}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <SoftInput
              label="Description (Optional)"
              value={newHoliday?.description}
              onChange={(e) => setNewHoliday({ ...newHoliday, description: e.target.value })}
              multiline
              rows={3}
              fullWidth
            />
          </SoftBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleAddHoliday} variant="contained" color="primary">
            Add Holiday
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Holiday Details Dialog */}
      <Dialog
        open={viewDialogOpen}
        onClose={() => setViewDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Holiday Details</DialogTitle>
        <DialogContent>
          {selectedEvent && (
            <SoftBox display="flex" flexDirection="column" gap={2} mt={1}>
              <SoftTypography variant="h6" color="info">
                {selectedEvent.title}
              </SoftTypography>
              <Box>
                <SoftTypography variant="body2" fontWeight="bold">
                  Date:
                </SoftTypography>
                <SoftTypography variant="body1">
                  {new Date(selectedEvent.start).toLocaleDateString("en-IN", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </SoftTypography>
              </Box>
              {selectedEvent.extendedProps.description && (
                <Box>
                  <SoftTypography variant="body2" fontWeight="bold">
                    Description:
                  </SoftTypography>
                  <SoftTypography variant="body1" color="textSecondary">
                    {selectedEvent.extendedProps?.description}
                  </SoftTypography>
                </Box>
              )}
              {selectedEvent.extendedProps.isExcelData && (
                <SoftTypography variant="caption" color="success.main" fontStyle="italic">
                  • New holiday (Pending Upload)
                </SoftTypography>
              )}
            </SoftBox>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewDialogOpen(false)} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </SoftBox>
  );
};

export default Holiday;
